import { render } from "./PasswordVerificationPrompt.vue?vue&type=template&id=718fb51c&scoped=true"
import script from "./PasswordVerificationPrompt.vue?vue&type=script&lang=ts"
export * from "./PasswordVerificationPrompt.vue?vue&type=script&lang=ts"

import "./PasswordVerificationPrompt.vue?vue&type=style&index=0&id=718fb51c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-718fb51c"

export default script